import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import feather from 'feather-icons';
import SideBarTriggerContext from '../../../context/SideBarTriggerContext';
import fdoLogo from "../../../assets/images/fdo.png"
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../../context/AuthContext';

function Sidebar() {

    const navigate = useNavigate();
    const { user } = useContext(AuthContext)

    useEffect(() => {
        feather.replace();
      }, []);
      

      const { triggerSideBar } = useContext(SideBarTriggerContext);
      const { logout } = useContext(AuthContext);

    return (
        <div className={`page-sidebar  ${triggerSideBar ? 'open' : ''}`}>
        <div className="main-header-left d-none d-lg-block">
          <div className="logo-wrapper text-center">
            <a href="index.html">
            <img src={fdoLogo} alt="" style={{height: "60px"}}/>
            </a></div>
        </div>
        <div className="sidebar custom-scrollbar">
          <div className="sidebar-user text-center">
            <div>
                <img className="img-60 rounded-circle"  src={user.photo || "../assets/images/avtar/user.jpeg"} alt="#" />
              <div className="profile-edit"><Link to="/edit-profile"><i data-feather="edit"></i></Link></div>
            </div>
            <h6 className="mt-3 f-14">{user.first_name}</h6>
            <p>{user.user_type.replace(/_/g, ' ')}</p>
          </div>
          <ul className="sidebar-menu">
            <li>
                <Link className="sidebar-header" to="/">
                    <i data-feather="grid"></i>
                    <span>Dashboard</span>
                </Link>
            </li>
            <li>
                <Link className="sidebar-header" to="/edit-profile">
                    <i data-feather="user"></i>
                    <span>Profile</span>
                </Link>
            </li>
            {
                (user.user_type == "project_officer") && (
                    <>
                        <li>
                            <Link className="sidebar-header" to="/beneficiaries">
                                <i data-feather="users"></i>
                                <span>Beneficiaries</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="sidebar-header" to="/my-cases">
                                <i data-feather="folder"></i>
                                <span>My Cases</span>
                            </Link>
                        </li>
                    </>
                    
                )
            }

            {
                (user.user_type == "case_manager") && (
                    <>
                    <li>
                        <Link className="sidebar-header" to="/open-cases">
                            <i data-feather="folder-plus"></i>
                            <span>Open Cases</span>
                        </Link>
                    </li>
                    <li>
                        <Link className="sidebar-header" to="/my-cases">
                            <i data-feather="folder-minus"></i>
                            <span>My Cases</span>
                        </Link>
                    </li>
                    </>
                )
            }

            {
                (user.user_type == "project_manager") && (
                    <>
                        <li>
                            <Link className="sidebar-header" to="/beneficiaries">
                                <i data-feather="users"></i>
                                <span>Beneficiaries</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="sidebar-header" to="/open-cases">
                                <i data-feather="folder-plus"></i>
                                <span>Open Cases</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="sidebar-header" to="/my-cases">
                                <i data-feather="git-pull-request"></i>
                                <span>In-Review Cases</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="sidebar-header" to="/approved-cases">
                                <i data-feather="check-circle"></i>
                                <span>Approved Cases</span>
                            </Link>
                        </li>
                    </>
                )
            }
             {
                (user.user_type == "super_admin" || user.user_type == "admin") && (
                    <>
                        <li>
                            <Link className="sidebar-header" to="/manage-users">
                                <i data-feather="users"></i>
                                <span>Manage Users</span>
                            </Link>
                        </li>
                    </>
                )
            }

            <li>
                <Link className="sidebar-header" onClick={()=>logout()}>
                    <i data-feather="log-out"></i>
                    <span>Logout</span>
                </Link>
            </li>

            </ul>
        </div>
      </div>
    );
}

export default Sidebar;
